export const PATAGONIA_EDITOR_REDESIGN_OPTIN_NAME = 'patagonia-redesign-user-test';